/* eslint-disable @typescript-eslint/naming-convention */
import { remove } from '@core/api/baseApi';
import { DeleteOrganizationLogoResponse } from '@core/types/ApiResponses';

const deleteOrganizationLogo = (mode: string): Promise<DeleteOrganizationLogoResponse> =>
  remove(`/organizations/custom-logo/${mode}`);

export { deleteOrganizationLogo };
